import UserAvatarWithStats from './UserAvatarWithStats'
export default UserAvatarWithStats
